import FingerprintJS from "@fingerprintjs/fingerprintjs";

import { LOCAL_STORAGE_KEY } from "../../constant/common";
import { getItemFromLocalStorage, setItemInLocalStorage } from "../../hooks/localStorage";
import { consoleLog } from "../consoleLog/consoleLog";

export async function getDeviceId() {
  const fp = await FingerprintJS.load();
  const result = await fp.get();
  return result.visitorId; // Stable across normal & incognito mode
}

/**
 * Return the app's canonical device id (raw FingerprintJS visitorId) for use in
 * request payloads (e.g. promo apply/remove). Prefers the value cached at app
 * init in localStorage `_zenvoya_device_id`; falls back to computing it (and
 * caches it, mirroring useAppInitialization). Returns "" if it can't be resolved.
 */
export async function getStoredDeviceId(): Promise<string> {
  try {
    const data = getItemFromLocalStorage(LOCAL_STORAGE_KEY.deviceId);
    const parsed = typeof data === "string" ? JSON.parse(data) : data;
    if (parsed?.id) return parsed.id;
    const id = await getDeviceId();
    if (!parsed) setItemInLocalStorage(LOCAL_STORAGE_KEY.deviceId, { id, count: 0 });
    return id || "";
  } catch {
    return "";
  }
}

export function updateRateLimitCount() {
  const data = getItemFromLocalStorage(LOCAL_STORAGE_KEY.deviceId);
  consoleLog(["RATE LIMIT", data]);
  if (!data) return;
  let parseData = typeof data === "string" ? JSON.parse(data) : data;
  parseData = { ...parseData, count: parseData.count + 1 };
  setItemInLocalStorage(LOCAL_STORAGE_KEY.deviceId, JSON.stringify(parseData));
}

export function checkIfRateLimitExceed(isLoggedIn: boolean, appConfig: any) {
  if (isLoggedIn) return false;
  const data = getItemFromLocalStorage(LOCAL_STORAGE_KEY.deviceId);
  if (!data) return false;
  let parseData = typeof data === "string" ? JSON.parse(data) : data;
  if (parseData?.count < (Number(appConfig?.find((ele: any) => ele?.key === "RATE_LIMIT")?.value) || 1000)) return false;
  else return true;
}
